<template>
  <div class="inline-flex items-center w-full">
    <div
      v-if="$store.state.isSearch || $route.path === '/settings'"
      class="p-2 rounded-full bg-white dark:bg-transparent m-1 cursor-pointer focus:outline-none outline-none"
      @click="back()"
    >
      <svg
        alt="Bouton retour"
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="19" y1="12" x2="5" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline>
      </svg>
    </div>

    <div
      v-else
      class="p-2 rounded-full bg-white dark:bg-transparent dark:text-slate-400 m-1 cursor-pointer focus:outline-none outline-none umami--click--button-settings"
      @click="settings()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="3"></circle>
        <path
          d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
        ></path>
      </svg>
    </div>
    <div
      v-if="$route.path !== '/settings'"
      class="relative text-gray-800 bg-white dark:bg-transparent rounded-full w-full"
      :class="{
        'w-full': $store.state.isSearch,
        'w-full': $store.state.isSearch == false
      }"
      @click="startSearch()"
    >
      <input
        v-model="$store.state.query"
        @input="search"
        type="search"
        placeholder="On part de quel arrêt ?"
        class="h-10 px-5 pl-10 text-sm rounded-full focus:outline-none cursor-text w-full dark:bg-[#27282a] dark:text-white"
      />
      <div
        alt="icone recherche"
        class="absolute left-0 top-0 mt-3 ml-4 cursor-pointer dark:text-white"
      >
        <svg
          class="h-4 w-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 56.966 56.966"
          style="enable-background:new 0 0 56.966 56.966;"
          xml:space="preserve"
          width="512px"
          height="512px"
        >
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
          />
        </svg>
      </div>
    </div>
    <div v-else>
      <h2 class="text-gray-800 dark:text-white text-lg pl-5 select-none">
        Préférences de l'application
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  methods: {
    search(e) {
      this.$store.commit("search", e.target.value || " ");
    },
    startSearch() {
      this.$store.commit("startSearch");
    },
    back() {
      this.$store.commit("search", "");
      this.$store.commit("selectLineFilter", null);
      this.$router.push({ name: "home" });
    },
    settings() {
      this.$router.push({ name: "settings" });
    }
  }
};
</script>
